import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {withRouter} from "react-router-dom";
import withPermissions from "../WithPermissions";

class UsersTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true
        }

    }
    handleTicketDetail = (customerId) => {
        this.props.history.push(`/ticket-detail/${customerId}`);
    }
    render() {
        const {pending} = this.state;
        const columns = [
            {
                name:'ID',
                selector:row => row.id,
                sortable:true
            },
            {
                name:'Başlık',
                selector:row => row.title,
                sortable:true
            },

            {
                name: 'Durum',
                selector: row => row.status,
                cell: row => {
                    if (row.status === "yeni talep") {
                        return <span className="badge badge-default">Yeni Talep</span>;
                    } else if (row.status === "işlemde") {
                        return <span className="badge badge-primary">İşlemde</span>;
                    } else if (row.status === "kapandı") {
                        return <span className="badge badge-success">Kapandı</span>;
                    } else {

                    }
                }
            },


        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/tickets/all"}
                columns={columns}
                onRowClicked={row => this.handleTicketDetail(row.id)}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(UsersTable));
